module.exports = __webpack_public_path__ + "img/1ee16c6.png";